import type { ListingResponse } from '../models';
import { formatListing } from '../pages/TenantScreeningServicesPage/ListingWizardPage/EnterYourAddressStep/EnterYourAddressStep.utils';

export function getListingFromAddressString({
  listings,
  address,
}: {
  listings?: Array<ListingResponse>;
  address?: string;
}) {
  return listings?.length && listings.find((listing) => formatListing(listing).address === address);
}
